import { IonSpinner } from '@ionic/react';
import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { t } from 'ttag';

import { ReactComponent as EMLeadCaptureLogoLight } from '@assets/lead-capture-app-logo.svg';
import Content from '@components/Content';
import Platform from '@custom-types/Platform';

const AppStoreLinks = {
  [Platform.Ios]: 'https://apps.apple.com/us/app/lead-capture-by-eventmobi/id6461824837',
  [Platform.Android]:
    'https://play.google.com/store/apps/details?id=com.eventmobi.leadcapture&pli=1',
};

const KNOWLEDGE_BASE_URL = 'https://help.eventmobi.com/en/knowledge/using-the-lead-capture-app';

const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
`;

const OpenApp = () => {
  const { platform } = useParams<{ platform: Platform.Ios | Platform.Android }>();

  if ([Platform.Ios, Platform.Android].includes(platform)) {
    window.location.replace(AppStoreLinks[platform]);
  } else {
    window.location.replace(KNOWLEDGE_BASE_URL);
  }

  return (
    <Content>
      <Body>
        <EMLeadCaptureLogoLight />
        <h3>{t`Redirecting to Lead Capture App`}</h3>
        <IonSpinner name="circular" color="primary" />
      </Body>
    </Content>
  );
};

export default OpenApp;
